import { TableCellPerColumn } from "ds/components/TableSimple/types";

import { ScanRunsListItem } from "../../../types";
import { SCAN_RUNS_COLUMN_ID } from "../constants";
import ScanRunsTableDurationCell from "./DurationCell";
import ScanRunsTableScheduledCell from "./ScheduledCell";
import ScanRunsTableSettingsCell from "./SettingsCell";
import ScanRunsTableStatusCell from "./StatusCell";
import ScanRunsTableTotalResourcesCell from "./TotalResourcesCell";
import ScanRunsTableUnmanagedResourcesCell from "./UnmanagedResourcesCell";

const SCAN_RUNS_TABLE_CELLS: TableCellPerColumn<ScanRunsListItem> = {
  [SCAN_RUNS_COLUMN_ID.SCHEDULED]: ScanRunsTableScheduledCell,
  [SCAN_RUNS_COLUMN_ID.STATUS]: ScanRunsTableStatusCell,
  [SCAN_RUNS_COLUMN_ID.DURATION]: ScanRunsTableDurationCell,
  [SCAN_RUNS_COLUMN_ID.TOTAL_RESOURCES]: ScanRunsTableTotalResourcesCell,
  [SCAN_RUNS_COLUMN_ID.UNMANAGED_RESOURCES]: ScanRunsTableUnmanagedResourcesCell,
  [SCAN_RUNS_COLUMN_ID.SETTINGS]: ScanRunsTableSettingsCell,
};

export default SCAN_RUNS_TABLE_CELLS;
